function Contact() {
    return (
        <div className="contact">
            <div className="intro">
                <h2 className="tips-headline">My Sustainable Brands Developers.</h2>
                <p className="tips-text">Learn a little more about the team that developed My Sustainable Brands. Feel free to reach out if you have any questions!</p>
                <div className="people-container">
                    <div className="person">
                        <h2 className="brand-headline">Nicole Baird</h2>
                        <p className="brand-details">Front-End Lead: Front-End Development, React, CSS, Wireframes</p>
                        <div className="icons">
                        <a href="https://www.linkedin.com/in/nicole-k-baird/" target="_blank"><img className="icon" src="https://res.cloudinary.com/dhbumhhh1/image/upload/v1644258882/my-sustainable-brand/linkedin_1_xrgrsr.png" alt="linkedin" /></a>
                        <a href="https://github.com/nbaird4889" target="_blank"><img className="icon" src="https://res.cloudinary.com/dhbumhhh1/image/upload/v1644258931/my-sustainable-brand/github_ctm6jv.png" alt="github" /></a>
                        </div>
                    </div>

                    <div className="person">
                        <h2 className="brand-headline">June Holmberg</h2>
                        <p className="brand-details">Scrum Master: React, Auth, Full-Stack Development, Trello Board, README</p>
                        <div className="icons">
                            <a href="https://www.linkedin.com/in/june-holmberg/" target="_blank"><img className="icon" src="https://res.cloudinary.com/dhbumhhh1/image/upload/v1644258882/my-sustainable-brand/linkedin_1_xrgrsr.png" alt="linkedin" /></a>
                            <a href="https://github.com/jmch-git" target="_blank"><img className="icon" src="https://res.cloudinary.com/dhbumhhh1/image/upload/v1644258931/my-sustainable-brand/github_ctm6jv.png" alt="github" /></a>
                        </div>
                    </div>

                    <div className="person">
                        <h2 className="brand-headline">David Dugas</h2>
                        <p className="brand-details">Scrum Master: Backend Lead: React, Auth, Database Management/ERD Modeling, Full-Stack Development</p>
                        <div className="icons">
                        <a href="https://www.linkedin.com/in/david-dugas-0160792a/" target="_blank"><img className="icon" src="https://res.cloudinary.com/dhbumhhh1/image/upload/v1644258882/my-sustainable-brand/linkedin_1_xrgrsr.png" alt="linkedin" /></a>
                        <a href="https://github.com/dugad059/" target="_blank"><img className="icon" src="https://res.cloudinary.com/dhbumhhh1/image/upload/v1644258931/my-sustainable-brand/github_ctm6jv.png" alt="github" /></a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Contact